/**
 * EmojiPickerWrapper — lazy-loads the heavy emoji-picker-react bundle
 * (~2MB of emoji data) only when the picker is first opened.
 *
 * Using React.lazy ensures the entire emoji-picker-react module is placed
 * in a separate code-split chunk and not included in the initial JS bundle.
 */
import React, { lazy, Suspense } from 'react';

// Type-only import for the callback signature — erased at compile time.
import type { EmojiClickData } from 'emoji-picker-react';
// Runtime import of ONLY the Categories enum (a tiny constant).
// The heavy emoji data lives in the default export, which is lazy-loaded below.
import { Categories } from 'emoji-picker-react';

const LazyEmojiPicker = lazy(() => import('emoji-picker-react'));

// Module-level constant — computed once, never re-created between renders.
const EMOJI_CATEGORIES = [
  { category: Categories.SUGGESTED, name: 'Frequentemente Usados' },
  { category: Categories.SMILEYS_PEOPLE, name: 'Sorrisos e Pessoas' },
  { category: Categories.ANIMALS_NATURE, name: 'Animais e Natureza' },
  { category: Categories.FOOD_DRINK, name: 'Comida e Bebida' },
  { category: Categories.TRAVEL_PLACES, name: 'Viagens e Lugares' },
  { category: Categories.ACTIVITIES, name: 'Atividades' },
  { category: Categories.OBJECTS, name: 'Objetos' },
  { category: Categories.SYMBOLS, name: 'Símbolos' },
  { category: Categories.FLAGS, name: 'Bandeiras' },
];

const PREVIEW_CONFIG = {
  defaultCaption: 'Escolha um emoji...',
  showPreview: false,
};

/** Placeholder with the same dimensions as the picker to prevent layout shift. */
function PickerFallback() {
  return <div style={{ width: 350, height: 450 }} />;
}

interface EmojiPickerWrapperProps {
  onEmojiClick: (data: EmojiClickData) => void;
}

export const EmojiPickerWrapper = React.memo(function EmojiPickerWrapper({
  onEmojiClick,
}: EmojiPickerWrapperProps) {
  return (
    <Suspense fallback={<PickerFallback />}>
      <LazyEmojiPicker
        onEmojiClick={onEmojiClick}
        height={450}
        width={350}
        searchPlaceholder="Pesquisar..."
        previewConfig={PREVIEW_CONFIG}
        categories={EMOJI_CATEGORIES}
      />
    </Suspense>
  );
});
